module.exports = __webpack_public_path__ + "img/BFT.b7f4c425.svg";